// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

.sidenav-container {
  height: 100%;
}
.sidenav-container .sidenav::ng-deep .mat-drawer-inner-container {
  overflow-x: hidden;
}
.sidenav-container .sidenav {
  width: 205px;
  background-color: #26344B;
}
.sidenav-container .sidenav.minimized-filter {
  max-width: 70px !important;
}
.sidenav-container .sidenav.minimized-filter .nav-logo-wrapper {
  height: 48px;
  min-width: 55px;
  width: 100%;
}
.sidenav-container .sidenav.minimized-filter .nav-logo-wrapper img.mini-logo {
  width: 40px !important;
}
.sidenav-container .mat-badge-content {
  background: red !important;
  color: blue !important;
}
@keyframes color_change {
  from {
    color: white;
  }
  to {
    color: rgba(255, 255, 255, 0.498);
  }
}
.sidenav-container .toolbar-container {
  position: sticky;
  top: 0;
  z-index: 1000;
}
.sidenav-container .toolbar-container .notifications {
  padding-top: 10px;
  margin-right: 10px;
}
.sidenav-container .toolbar-container .notifications mat-icon {
  color: white;
}
.sidenav-container .toolbar-container .downloads {
  padding-top: 10px;
  margin-right: 10px;
}
.sidenav-container .toolbar-container .downloads mat-icon {
  animation: color_change 1s infinite alternate;
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.sidenav-container .mat-toolbar {
  background-color: #0175c0 !important;
  background: linear-gradient(45deg, #04488f, transparent);
  color: #fff;
}
.sidenav-container .mat-toolbar.dev {
  border-bottom: 8px solid orange;
}
.sidenav-container .mat-toolbar.demo {
  border-bottom: 8px solid rgb(86, 162, 18);
}
.sidenav-container .mat-toolbar.mat-primary {
  position: sticky;
  top: 0;
  z-index: 1;
}
.sidenav-container .example-spacer {
  flex: 1 1 auto;
}
.sidenav-container img.logo {
  width: 180px;
}
.sidenav-container mat-icon {
  color: #4d5d7c;
  margin-right: 10px;
}
.sidenav-container hr.separator {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #374d70;
  margin: 0;
  padding: 0;
}
.sidenav-container hr.separator.hidden {
  display: none;
}
.sidenav-container .router-wrapper {
  padding-left: 0px;
  padding-right: 0px;
}
.sidenav-container .page-title {
  padding-left: 5px;
}
.sidenav-container avatar {
  width: 50px;
  height: 50px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep {
  background: transparent;
  box-shadow: unset;
  background-color: #2b3b54;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-content .mat-expansion-panel-body {
  padding: 0px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-content .mat-expansion-panel-body .mat-mdc-list-item {
  height: 32px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-content .mat-expansion-panel-body .mat-mdc-list-item .item-label {
  font-size: 12px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-content .mat-expansion-panel-body .mat-mdc-list-item .mdc-list-item__content {
  padding-left: 15px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-content .mat-expansion-panel-body mat-icon {
  font-size: 20px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-indicator:after {
  color: #c3cee0;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header {
  padding: 0 16px;
  font-size: 14px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header.mat-expanded {
  height: 37px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header.mat-expanded {
  background: #1f2b3d;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header.mat-expanded .mat-expansion-panel-header-title {
  color: #fff;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header.mat-expanded mat-icon {
  color: #fff;
  font-size: 20px;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header.mat-expanded .mat-expansion-indicator:after {
  color: #fff;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header mat-panel-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  height: inherit;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header-title {
  color: #c3cee0;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header-title.item-active {
  background: #1f2b3d;
  color: #fff;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header-title.item-active mat-icon {
  color: #18cdc4;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header-title.item-active .mat-expansion-indicator:after {
  color: #fff;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header-title:hover {
  color: #fff;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header-title:hover mat-icon {
  color: #fff;
}
.sidenav-container mat-accordion .mat-expansion-panel ::ng-deep .mat-expansion-panel-header-title:hover .mat-expansion-indicator:after {
  color: #fff;
}
.sidenav-container .mat-drawer-side {
  border-right: 0px;
}
.sidenav-container .nav-logo-wrapper {
  background: #7d478e;
  width: 100%;
  min-height: 64px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.sidenav-container .nav-logo-wrapper .minimize-menu {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 25px;
  height: 25px;
}
.sidenav-container .nav-logo-wrapper mat-icon {
  margin: 0;
  color: white;
}
.sidenav-container .nav-logo-wrapper.dev {
  background-color: orange;
}
.sidenav-container .nav-logo-wrapper.demo {
  background-color: rgb(86, 162, 18);
}
.sidenav-container .mat-mdc-list-item::ng-deep .item-label,
.sidenav-container .mat-mdc-list-item::ng-deep .mdc-list-item__primary-text {
  color: #c3cee0;
  font-size: 14px;
}
.sidenav-container .mat-mdc-list-item::ng-deep mat-icon {
  vertical-align: middle;
}
.sidenav-container .mat-mdc-list-item:hover * {
  color: #fff !important;
}
.sidenav-container .mat-mdc-list-item.item-active {
  background: #1f2b3d;
}
.sidenav-container .mat-mdc-list-item.item-active .item-label,
.sidenav-container .mat-mdc-list-item.item-active .mdc-list-item__content {
  color: #fff;
}
.sidenav-container .mat-mdc-list-item.item-active mat-icon {
  color: #18cdc4;
}
.sidenav-container .mat-mdc-list-base {
  padding-top: 0px;
}
.sidenav-container .page-footer {
  padding: 8px 20px 5px;
  font-size: 12px;
  height: 33px;
}
.sidenav-container .sidenav-filter-field {
  color: white;
  margin-left: 15px;
  margin-right: 15px;
  width: 170px;
}
.sidenav-container .sidenav-filter-field mat-icon {
  color: white;
  font-size: 18px;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-form-field-ripple {
  background-color: rgba(255, 255, 255, 0.7) !important;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-form-field-underline {
  /*change color of underline*/
  background-color: rgba(255, 255, 255, 0.7) !important;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-form-field-label {
  color: rgba(255, 255, 255, 0.7) !important;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-input-element {
  color: rgba(255, 255, 255, 0.7) !important;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-form-field-underline {
  /*change color of underline*/
  background-color: rgba(255, 255, 255, 0.7) !important;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-form-field-underline::hover {
  /*change color of underline*/
  background-color: rgba(255, 255, 255, 0.7) !important;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-form-field-wrapper {
  padding-bottom: 0;
}
.sidenav-container ::ng-deep .sidenav-filter-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/components/logged-layout/logged-layout.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAfA;EACE,YAAA;AAkBF;AAfI;EACE,kBAAA;AAiBN;AAbE;EACE,YAAA;EACA,yBDgDa;ACjCjB;AAdI;EACE,0BAAA;AAgBN;AAfM;EACE,YAAA;EAEA,eAAA;EACA,WAAA;AAgBR;AAfQ;EACE,sBAAA;AAiBV;AAXE;EACE,0BAAA;EACA,sBAAA;AAaJ;AAVE;EACE;IACE,YAAA;EAYJ;EAVE;IACE,iCAAA;EAYJ;AACF;AATE;EAEE,gBAAA;EACA,MAAA;EACA,aAAA;AAWJ;AAVI;EACE,iBAAA;EACA,kBAAA;AAYN;AAXM;EACE,YAAA;AAaR;AATI;EACE,iBAAA;EACA,kBAAA;AAWN;AAVM;EACE,6CAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAYR;AAPE;EAEE,oCAAA;EACA,wDAAA;EACA,WAAA;AAQJ;AAPI;EACE,+BAAA;AASN;AAPI;EACE,yCAAA;AASN;AAJE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;AAMJ;AAHE;EACE,cAAA;AAKJ;AAFE;EACE,YAAA;AAIJ;AADE;EAEE,cAAA;EACA,kBAAA;AAEJ;AACE;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;AACJ;AAAI;EACE,aAAA;AAEN;AAEE;EAGE,iBAAA;EACA,kBAAA;AAFJ;AAME;EACE,iBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;AALJ;AAgBI;EACE,uBAAA;EACA,iBAAA;EACA,yBAAA;AAdN;AAgBM;EACE,YAAA;AAdR;AAeQ;EACE,YAAA;AAbV;AAcU;EACE,eAAA;AAZZ;AAeQ;EACE,kBAAA;AAbV;AAgBQ;EACE,eAAA;AAdV;AAkBM;EACE,cAAA;AAhBR;AAmBM;EACE,eAAA;EACA,eAAA;AAjBR;AAmBQ;EACE,YAAA;AAjBV;AAoBQ;EACE,mBAAA;AAlBV;AAoBU;EACE,WAAA;AAlBZ;AAoBU;EACE,WAAA;EACA,eAAA;AAlBZ;AAqBU;EACE,WAAA;AAnBZ;AAsBQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AApBV;AAwBM;EACE,cAAA;AAtBR;AAuBQ;EACE,mBAAA;EACA,WAAA;AArBV;AAuBU;EACE,cAAA;AArBZ;AAuBU;EACE,WAAA;AArBZ;AAyBQ;EACE,WAAA;AAvBV;AAyBU;EACE,WAAA;AAvBZ;AAyBU;EACE,WAAA;AAvBZ;AA8BE;EACE,iBAAA;AA5BJ;AA+BE;EACE,mBD9Ha;EC+Hb,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA7BJ;AA8BI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA5BN;AA8BI;EACE,SAAA;EACA,YAAA;AA5BN;AA8BI;EACE,wBAAA;AA5BN;AA8BI;EACE,kCAAA;AA5BN;AAiCI;;EAEE,cAAA;EACA,eAAA;AA/BN;AAkCI;EACE,sBAAA;AAhCN;AAsCM;EACE,sBAAA;AApCR;AAuCI;EACE,mBAAA;AArCN;AAuCM;;EAEE,WAAA;AArCR;AAwCM;EACE,cAAA;AAtCR;AA2CE;EACE,gBAAA;AAzCJ;AA4CE;EACE,qBAAA;EACA,eAAA;EACA,YAAA;AA1CJ;AA6CE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AA3CJ;AA4CI;EACE,YAAA;EACA,eAAA;AA1CN;AA8CE;EACE,qDAAA;AA5CJ;AA8CE;EACE,4BAAA;EACA,qDAAA;AA5CJ;AA+CE;EACE,0CAAA;AA7CJ;AAgDE;EACE,0CAAA;AA9CJ;AAiDE;EACE,0CAAA;AA/CJ;AAiDE;EACE,4BAAA;EACA,qDAAA;AA/CJ;AAiDE;EACE,4BAAA;EACA,qDAAA;AA/CJ;AAkDE;EACE,iBAAA;AAhDJ;AAkDE;EACE,wBAAA;AAhDJ","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@import \"../../../theme/theme.scss\";\n\n.sidenav-container {\n  height: 100%;\n\n  .sidenav::ng-deep {\n    .mat-drawer-inner-container {\n      overflow-x: hidden;\n    }\n  }\n\n  .sidenav {\n    width: 205px;\n    background-color: $comv-dark-blue;\n    &.minimized-filter {\n      max-width: 70px !important;\n      & .nav-logo-wrapper {\n        height: 48px;\n        // width: 55px;\n        min-width: 55px;\n        width: 100%;\n        & img.mini-logo {\n          width: 40px !important;\n        }\n      }\n    }\n  }\n\n  .mat-badge-content {\n    background: red !important;\n    color: blue !important;\n  }\n\n  @keyframes color_change {\n    from {\n      color: white;\n    }\n    to {\n      color: rgba(255, 255, 255, 0.498);\n    }\n  }\n\n  .toolbar-container {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n    & .notifications {\n      padding-top: 10px;\n      margin-right: 10px;\n      mat-icon {\n        color: white;\n      }\n    }\n\n    & .downloads {\n      padding-top: 10px;\n      margin-right: 10px;\n      mat-icon {\n        animation: color_change 1s infinite alternate;\n        font-size: 28px;\n        width:28px;\n        height: 28px;\n      }\n    }\n  }\n\n  .mat-toolbar {\n    //background-color: $comv-blue-medium !important;\n    background-color: $comv-blue-medium !important;\n    background: linear-gradient(45deg, $comv-blue-dark, transparent);\n    color: #fff;\n    &.dev {\n      border-bottom: 8px solid orange;\n    }\n    &.demo {\n      border-bottom:8px solid rgb(86, 162, 18);\n      \n    }\n  }\n\n  .mat-toolbar.mat-primary {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n\n  .example-spacer {\n    flex: 1 1 auto;\n  }\n\n  img.logo {\n    width: 180px;\n  }\n\n  mat-icon {\n    //color: rgb(179, 148, 101);\n    color: #4d5d7c;\n    margin-right: 10px;\n  }\n\n  hr.separator {\n    display: block;\n    height: 1px;\n    border: 0;\n    border-top: 1px solid #374d70;\n    margin: 0;\n    padding: 0;\n    &.hidden {\n      display: none;\n    }\n  }\n\n  .router-wrapper {\n    //your styles\n    //padding:20px;\n    padding-left: 0px; //@margintable\n    padding-right: 0px;\n    // margin-top: 84px;\n  }\n\n  .page-title {\n    padding-left: 5px;\n  }\n\n  avatar {\n    width: 50px;\n    height: 50px;\n  }\n\n  // .material-icons {\n  //   font-size: 22px;\n  //   height: 28px;\n  //   width: 28px;\n  // }\n\n  // accordion menu style\n  mat-accordion {\n    .mat-expansion-panel ::ng-deep {\n      background: transparent;\n      box-shadow: unset;\n      background-color: #2b3b54;\n\n      .mat-expansion-panel-content .mat-expansion-panel-body {\n        padding: 0px;\n        .mat-mdc-list-item {\n          height: 32px;\n          .item-label {\n            font-size: 12px;\n          }\n        }\n        .mat-mdc-list-item .mdc-list-item__content {\n          padding-left: 15px;\n        }\n\n        mat-icon {\n          font-size: 20px;\n        }\n      }\n\n      .mat-expansion-indicator:after {\n        color: #c3cee0;\n      }\n\n      .mat-expansion-panel-header {\n        padding: 0 16px;\n        font-size: 14px;\n\n        &.mat-expanded {\n          height: 37px;\n        }\n\n        &.mat-expanded {\n          background: #1f2b3d;\n\n          .mat-expansion-panel-header-title {\n            color: #fff;\n          }\n          mat-icon {\n            color: #fff;\n            font-size: 20px;\n          }\n\n          .mat-expansion-indicator:after {\n            color: #fff;\n          }\n        }\n        mat-panel-title {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          box-sizing: border-box;\n          position: relative;\n          height: inherit;\n        }\n      }\n\n      .mat-expansion-panel-header-title {\n        color: #c3cee0;\n        &.item-active {\n          background: #1f2b3d;\n          color: #fff;\n\n          mat-icon {\n            color: #18cdc4;\n          }\n          .mat-expansion-indicator:after {\n            color: #fff;\n          }\n        }\n\n        &:hover {\n          color: #fff;\n\n          mat-icon {\n            color: #fff;\n          }\n          .mat-expansion-indicator:after {\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n\n  .mat-drawer-side {\n    border-right: 0px;\n  }\n\n  .nav-logo-wrapper {\n    background: $comv-pink-dark;\n    width: 100%;\n    min-height: 64px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    & .minimize-menu {\n      position: absolute;\n      bottom: 0px;\n      right: 0px;\n      width: 25px;\n      height: 25px;\n    }\n    & mat-icon {\n      margin: 0;\n      color: white;\n    }\n    &.dev {\n      background-color: orange;\n    }\n    &.demo {\n      background-color: rgb(86, 162, 18);      \n    }\n  }\n\n  .mat-mdc-list-item::ng-deep {\n    .item-label,\n    .mdc-list-item__primary-text {\n      color: #c3cee0;\n      font-size: 14px;\n    }\n\n    mat-icon {\n      vertical-align: middle;\n    }\n  }\n\n  .mat-mdc-list-item {\n    &:hover {\n      * {\n        color: #fff !important;\n      }\n    }\n    &.item-active {\n      background: #1f2b3d;\n\n      .item-label,\n      .mdc-list-item__content {\n        color: #fff;\n      }\n\n      mat-icon {\n        color: #18cdc4;\n      }\n    }\n  }\n\n  .mat-mdc-list-base {\n    padding-top: 0px;\n  }\n\n  .page-footer {\n    padding: 8px 20px 5px;\n    font-size: 12px;\n    height: 33px;\n  }\n\n  .sidenav-filter-field {\n    color: white;\n    margin-left: 15px;\n    margin-right: 15px;\n    width: 170px;\n    mat-icon {\n      color: white;\n      font-size: 18px;\n    }\n  }\n\n  ::ng-deep .sidenav-filter-field .mat-mdc-form-field-ripple {\n    background-color: rgba(255, 255, 255, 0.7) !important;\n  }\n  ::ng-deep .sidenav-filter-field .mat-mdc-form-field-underline {\n    /*change color of underline*/\n    background-color: rgba(255, 255, 255, 0.7) !important;\n  }\n\n  ::ng-deep .sidenav-filter-field .mat-mdc-form-field-label {\n    color: rgba(255, 255, 255, 0.7) !important;\n  }\n\n  ::ng-deep .sidenav-filter-field .mat-mdc-input-element {\n    color: rgba(255, 255, 255, 0.7) !important;\n  }\n\n  ::ng-deep .sidenav-filter-field .mat-icon {\n    color: rgba(255, 255, 255, 0.7) !important;\n  }\n  ::ng-deep .sidenav-filter-field .mat-mdc-form-field-underline {\n    /*change color of underline*/\n    background-color: rgba(255, 255, 255, 0.7) !important;\n  }\n  ::ng-deep .sidenav-filter-field .mat-mdc-form-field-underline::hover {\n    /*change color of underline*/\n    background-color: rgba(255, 255, 255, 0.7) !important;\n  }\n\n  ::ng-deep .sidenav-filter-field .mat-mdc-form-field-wrapper {\n    padding-bottom: 0;\n  }\n  ::ng-deep .sidenav-filter-field .mat-mdc-form-field-subscript-wrapper {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
